import React from 'react';
import { Link } from 'react-router-dom';

const Card = ({ title, description, to }) => (
  <Link
    to={to}
    className="panel border border-border p-6 hover:bg-muted transition block"
  >
    <div className="text-lg font-semibold text-foreground">{title}</div>
    <div className="text-sm text-muted-foreground mt-1">{description}</div>
  </Link>
);

export default function EntryPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-3xl">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground">Tri-Panel Admin</h1>
        <p className="text-sm sm:text-base text-muted-foreground mt-3">
          Choose which portal you want to access.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
          <Card title="SuperAdmin" description="System-wide management" to="/superadmin/login" />
          <Card title="Company Admin" description="Company operations" to="/admin/login" />
          <Card title="Customer" description="Customer chat" to="/customers/login" />
        </div>
      </div>
    </div>
  );
}
